import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule, WalkmeModule } from '@ot/shared/utils';
import { FooterModule } from '@ot/shared/footer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core.module';
import { SharedLegalNoticeModule } from '@ot/shared/legal-notice';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    AuthModule,
    WalkmeModule,
    FooterModule,
    SharedLegalNoticeModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
